export default "__VITE_ASSET__dZnFjPTW__"